import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import AsyncButton from "../../../../components/buttons/AsyncButton";
import { useOrderContext } from "../../../../contexts/OrderContext";
import useCreateInboundDeliveryMutation from "../../../../hooks/graphql-hooks/mutations/useCreateInboundDeliveryMutation";
import useEditInboundDeliveryMutation from "../../../../hooks/graphql-hooks/mutations/useEditInboundDeliveryMutation";
import { useProgression } from "../../../../hooks/useProgression";
import {
  mapToCreateInboundDeliveryInput,
  mapToEditInboundDeliveryInput,
} from "../../../../utils/mapper";
import OrderSummary from "../../components/summary/OrderSummary";
import BaseContent from "../BaseContent";
import "./SummaryScreen.scss";

interface SummaryScreenProps {
  setCreatedDeliveryId: (id: string) => void;
}

const SummaryScreen = (props: React.PropsWithChildren<SummaryScreenProps>) => {
  const { t } = useTranslation();
  const { id: idFromUrl } = useParams();
  const { savedProgress } = useOrderContext();
  const { goNext } = useProgression();

  const { setCreatedDeliveryId } = props;
  const isEditOrder = !!idFromUrl;

  const [createMutation, { loading: loadingCreate }] =
    useCreateInboundDeliveryMutation({
      dataAction: (id) => {
        setCreatedDeliveryId(id);
        goNext();
      },
    });

  const [editMutation, { loading: loadingEdit }] =
    useEditInboundDeliveryMutation({
      dataAction: () => {
        setCreatedDeliveryId(idFromUrl || "");
        goNext();
      },
    });

  const loading = isEditOrder ? loadingEdit : loadingCreate;
  const buttonText = isEditOrder ? "saveChanges" : "createInboundDelivery";

  const sendCreateMutation = () => {
    const createInboundDeliveryInput =
      mapToCreateInboundDeliveryInput(savedProgress);

    if (!createInboundDeliveryInput) return;

    createMutation({ variables: { createInboundDeliveryInput } }).catch(
      () => {},
    );
  };

  const sendEditMutation = () => {
    const editInboundDeliveryInput = mapToEditInboundDeliveryInput(
      idFromUrl || "",
      savedProgress,
    );
    if (!editInboundDeliveryInput) return;

    editMutation({ variables: { editInboundDeliveryInput } }).catch(() => {});
  };

  const renderConfirmOrderButton = (
    <AsyncButton
      sendRequest={isEditOrder ? sendEditMutation : sendCreateMutation}
      loading={loading}
      disabled={loading}
    >
      {t(buttonText)}
    </AsyncButton>
  );

  return (
    <BaseContent
      screenName={"summaryScreen"}
      disableNext={false}
      saveProgress={() => {}} // no new data is entered in this screen s owe don't need to save
      customProceedButton={renderConfirmOrderButton}
    >
      <OrderSummary isConfirmation={false} />
    </BaseContent>
  );
};

export default SummaryScreen;
